import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "AddAbonneModal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "addAbonneModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
          _createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Ajouter un abonné")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            ref: "abonneForm",
            onSubmit: $setup.addAbonne,
            "validation-schema": $setup.abonneSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Catégorie d'abonné "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "categorieAbonne",
                      modelValue: $setup.categorieAbonneId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.categorieAbonneId) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: $setup.categorieAbonneOptions,
                          searchable: true,
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          placeholder: "Sélectionner la catégorie de l'abonné",
                          onSelect: $setup.handleObjetInput
                        }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "categorieAbonne",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, [
                      _createTextVNode(_toDisplayString($setup.label1) + " ", 1),
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-danger" }, "*", -1))
                    ]),
                    _createVNode(_component_Field, {
                      name: "nomComplet",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: $setup.placeholder1
                    }, null, 8, ["placeholder"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nomComplet",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("label", _hoisted_13, [
                      _cache[9] || (_cache[9] = _createTextVNode(" Email ", -1)),
                      _createElementVNode("span", {
                        style: {"float":"right"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.sendOtp(true))),
                        class: "align-items-center"
                      }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "flaticon-send lh-1 me-8 position-relative top-1" }, null, -1),
                        _createTextVNode("Vérifier le mail ", -1)
                      ]))])
                    ]),
                    _createVNode(_component_Field, {
                      name: "email",
                      type: "email",
                      modelValue: $setup.email,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.email) = $event)),
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer l' email"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Téléphone "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "telephone",
                      modelValue: $setup.telephone,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.telephone) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_vue_tel_input, _mergeProps({
                          placeholder: "Entrer le numéro de téléphone",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          defaultCountry: "BJ",
                          mode: "international",
                          onValidate: $setup.validate,
                          class: "shadow-none fs-md-15 text-black py-2"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone",
                      class: "text-danger"
                    }),
                    (!$setup.validPhone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Veuillez entrer un numéro correcte"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                ($setup.showAdditionalFields)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Sexe "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "sexe",
                          type: "text"
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              searchable: true,
                              options: ['Masculin', 'Féminin'],
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Sélectionner le sexe" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "sexe",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Pays de résidence "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "nationalite",
                      modelValue: $setup.defaultCountriy,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.defaultCountriy) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: $setup.countries,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le pays de résidence" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nationalite",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Secteur d'activité "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "activite" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          options: $setup.secteurActiviteOptions,
                          searchable: true,
                          "track-by": "value",
                          label: "label",
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { placeholder: "Sélectionner le secteur d'activité" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "activite",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                      type: "submit",
                      disabled: !$setup.validPhone
                    }, " Créer un abonné ", 8, _hoisted_25)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.resetValue()))
        })
      ])
    ])
  ], 512))
}